<template>
  <v-dialog max-width="400" v-model="value" @input="$emit('input', value)">
    <v-card class="elevation-12 pa-3">
      <v-card-text class="text-center">
        <v-alert v-if="error" color="error" outlined class="alert-login-failed">
          {{ error }}
        </v-alert>
      </v-card-text>

      <v-form
        ref="form_redefinir_dados_pessoais"
        @submit="updateData"
        v-on:submit.prevent="() => false"
      >
        <v-card-text class="text-center">
          <img
            src="../assets/logo-empresta.svg"
            class="logo-empresta"
            alt="Empresta Bem Melhor"
            title="Empresta Bem Melhor"
          />
          <div>
            <h6 class="title font-weight-regular">
              Por favor informe seus dados Pessoais
            </h6>
          </div>
        </v-card-text>

        <v-card-text class="pl-0 pr-0">
          <v-text-field
            v-model="telefone"
            v-if="showPhone"
            name="telefone"
            id="telefone"
            label="Telefone pessoal"
            :type="'text'"
            v-mask="['(##) #####-####']"
            append-icon="phone"
            :rules="[
              (v) => !!v || 'Telefone pessoal é obrigatório',
              (v) =>
                v.length == 15 ||
                'Telefone pessoal precisa ter o ddd e pelo menos 9 numeros',
            ]"
            required
            class="mb-2"
            autocomplete="off"
            outlined
          ></v-text-field>

          <v-text-field
            v-model="email"
            v-if="showEmail"
            name="email"
            id="email"
            label="Email pessoal"
            :rules="[(v) => !!v || 'Email pessoal é obrigatório']"
            required
            :type="'email'"
            outlined
          ></v-text-field>
        </v-card-text>

        <v-card-actions class="pl-0 pr-0">
          <v-btn block large color="success" type="submit">Salvar</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <Loading :exibir="loading" />
  </v-dialog>
</template>

<script>
import Loading from "../components/Loading";
import axios from "axios";

export default {
  name: "AlterarDadosPessoais",
  props: ["showPhone", "showEmail", "value"],
  components: {
    Loading,
  },
  data: () => ({
    telefone: "",
    email: "",
    loading: false,
    error: '',
  }),
  methods: {
    async updateData(){
      const valido = await this.$refs.form_redefinir_dados_pessoais.validate()
      
      if(!valido) {
        return false
      }
      const request = axios.create({
        baseURL: process.env.VUE_APP_BASE_URI_API_GH,
      });
      const token = localStorage.getItem("token");
      this.loading = true;
      request
        .post(
          "user/update-dados-pessoais",
          {
            cpf: this.cpf,
            email: this.email,
            telefone: this.telefone,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((response) => {
          const data = response.data.data;
          if (data.sucesso) {
            localStorage.removeItem('redefinir_dados_pessoais');
            return this.$emit('closed')
          }
          this.error = response.data.message || "Não conseguimos salvar";
          this.loading = false;
        })
        .catch(() => {
          this.error = "Erro de comunicação com servidor!";
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.logo-empresta {
  height: 65px;
  margin-bottom: 10px;
}
</style>
